module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("The voice I hear this passing night was heard  "), _c('br'), _c('br'), _vm._v("In ancient days...  "), _c('br'), _c('br'), _vm._v("The same that oft-times hath  "), _c('br'), _c('br'), _vm._v("Charmed magic casements, opening on the foam  "), _c('br'), _c('br'), _vm._v("Of perilous seas, in faery lands forlorn.  "), _c('br'), _c('br'), _c('span', {
    staticClass: "Apple-converted-space"
  }), _vm._v("— Keats")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('b')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b97ae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section5.vue
// module id = 78
// module chunks = 0